import { Injectable } from '@angular/core';
import {Firestore, collection, doc, setDoc, deleteDoc, collectionData, updateDoc} from "@angular/fire/firestore";
import {CollectionReference, DocumentData} from "firebase/firestore";
import {Role, roleUpdate, User} from "../model/user";
import {Observable} from "rxjs";
import {AuthService} from "./auth.service";

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  usersRef: CollectionReference<DocumentData>;

  constructor(
    private afs: Firestore,
    private authService: AuthService,
  ) {
    this.usersRef = collection(this.afs, "users");
  }

  getAllOwners(): Observable<User[]>  {
    return collectionData(this.usersRef) as Observable<User[]>;
  }

  /**
   * Sets what a user may do. Roles are a set — somebody can run broadcasts and
   * sign off their club's evaluations at once — and `role` is kept in step as
   * the primary one, because that is what the broadcast screens and the older
   * security rules read.
   */
  setRoles(uid: string, roles: Role[], channelId?: number | null): Promise<void> {
    return updateDoc(doc(this.usersRef, uid), roleUpdate(roles, channelId));
  }

  getServerParams(): Observable<any[]> {
    return collectionData(collection(this.afs, 'serverParams')) as Observable<any[]>;
  }

  setServerParam(key: string, value: any): Promise<void> {
    return setDoc(doc(this.afs, `serverParams/${key}`), value);
  }

  deleteServerParam(key: string): Promise<void> {
    return deleteDoc(doc(this.afs, `serverParams/${key}`));
  }
}
